import { clientPath, LpBackendError, lpRequest } from '../../../../core/utils/lp-backend';
import { hasCoordinates } from './branch-shape';
import { getBranch } from './get-branch';

/**
 * `PATCH /client/:cid/branches/:id {name, store_code, dashboard_url, contact}`. A new logo goes through the existing
 * full-body `PUT /client/:cid/branch/` (multipart `image`), sent with the branch's current fields.
 */
export const editBranch = async (
  branch_id: string,
  name: string,
  store_code: string,
  dashboard_url: string,
  contact: string,
  branch_logo?: File | null
): Promise<any> => {
  await lpRequest('PATCH', clientPath(`/branches/${branch_id}`), {
    body: { name, store_code, dashboard_url, contact }
  });

  if (branch_logo) {
    // The PUT rewrites the location, so it needs the stored one, never the 0 fallback.
    const listed = ((await lpRequest('GET', clientPath('/branch'))) || []).find(
      (item: any) => item.id === branch_id
    );
    if (!hasCoordinates(listed?.location)) {
      throw new LpBackendError(
        "The details were saved, but the logo wasn't: this branch's location could not be read. Set its address, then upload the logo again.",
        409
      );
    }
    const branch = await getBranch(branch_id);
    const formData = new FormData();
    formData.append('id', branch_id);
    formData.append('name', branch.name);
    formData.append('address', branch.address || '');
    formData.append('hub_id', branch.hub_id);
    formData.append('latitude', String(branch.location.latitude));
    formData.append('longitude', String(branch.location.longitude));
    formData.append('contact', branch.contact || '');
    formData.append('store_code', branch.store_code || '');
    formData.append('image', branch_logo);

    await lpRequest('PUT', clientPath('/branch/'), { form: formData });
  }

  return getBranch(branch_id);
};
